import { graphql } from "./graphql";

export const RAIN_ONE_LISTS_QUERY = graphql(`
  query RainOneLists {
    rainOneLists {
      id
      key
      listName
    }
  }
`);

export const GENERATE_TASK_NAME_QUERY = graphql(`
  query GenerateTaskNameFromEmail($emailSubject: String!, $emailBody: String!) {
    generateTaskNameFromEmail(emailSubject: $emailSubject, emailBody: $emailBody) {
      taskName
      confidence
    }
  }
`);

export const ADD_TASK_FROM_OUTLOOK_MUTATION = graphql(`
  mutation AddTaskFromOutlook($input: AddTaskFromOutlookInput!) {
    addTaskFromOutlook(input: $input) {
      outlookTaskReply {
        messageMarkdown
        taskId
        url
      }
      errors {
        ... on ArgumentError {
          message
          paramName
        }
        ... on RainError {
          message
        }
      }
    }
  }
`);
